import { TrendingDown, TrendingUp } from 'lucide-react';
import React from 'react';
import { ui } from '../../styles/ui';

export const StatCard = ({ title, value, change, changeType, icon: IconComponent, tone = 'bg-indigo-600', delay = 0 }) => (
  <div className={`${ui.card} p-4 animate-fadeInUp`} style={{ animationDelay: `${delay}ms` }}>
    <div className="flex items-start justify-between">
      <div className="flex-1 min-w-0">
        <p className="text-gray-500 dark:text-gray-400 text-xs font-medium mb-1.5">{title}</p>
        <p className="text-2xl font-semibold text-gray-900 dark:text-white mb-1">{value}</p>
        {change && (
          <div className={`flex items-center text-xs font-medium ${changeType === 'positive' ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
            {changeType === 'positive' ? <TrendingUp className="h-3.5 w-3.5 mr-1" /> : <TrendingDown className="h-3.5 w-3.5 mr-1" />}
            {change}
          </div>
        )}
      </div>
      <div className={`p-2.5 rounded-lg ${tone} shrink-0`}>
        <IconComponent className="h-5 w-5 text-white" />
      </div>
    </div>
  </div>
);
